"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:5.1.4'] && _();
}
catch (e) { }
